export default "__VITE_ASSET__BklVEB4v__"